<div class="service-menu"
     [ngClass]="{
       'service-menu-horizontal': layout() === 'horizontal',
       'service-menu-vertical': layout() === 'vertical',
       'service-menu-sidebar': isInSidebar()
     }"
  >
  <div class="service-menu-content">

    <a
      class="service-menu-link g-main-link"
      [class.g-main-link-black]="isInSidebar()"
      routerLink="/skidki"
      routerLinkWithLang
    >
      {{ 'global.discounts' | translate }}
    </a>

    <a
      class="service-menu-link g-main-link"
      [class.g-main-link-black]="isInSidebar()"
      routerLink="/dostavka-i-oplata"
      routerLinkWithLang
    >
      {{ 'global.shipment_and_payment' | translate }}
    </a>

    <a
      class="service-menu-link g-main-link"
      [class.g-main-link-black]="isInSidebar()"
      routerLink="/vozvrat-tovara"
      routerLinkWithLang
    >
      {{ 'global.repayments' | translate }}
    </a>

    @if (isInFooter()) {
      <a
        class="service-menu-link g-main-link"
        [class.g-main-link-black]="isInSidebar()"
        routerLink="/politika-konfidencialnosti"
        routerLinkWithLang
      >
        {{ 'global.privacy_policy' | translate }}
      </a>
    }

    <a
      class="service-menu-link g-main-link"
      [class.g-main-link-black]="isInSidebar()"
      routerLink="/contacts"
      routerLinkWithLang
    >
      {{ 'global.contacts' | translate }}
    </a>

    <a
      class="service-menu-link g-main-link"
      [class.g-main-link-black]="isInSidebar()"
      routerLink="/blog"
      routerLinkWithLang
    >
      {{ 'global.blog' | translate }}
    </a>

    <a
      class="service-menu-link g-main-link"
      [class.g-main-link-black]="isInSidebar()"
      routerLink="/otzyvy"
      routerLinkWithLang
    >
      {{ 'global.reviews_about_us' | translate }}
      @if (storeReviewService.storeReviewsCount()) {
        <span class="service-menu-count"> ({{ storeReviewService.storeReviewsCount() }})</span>
      }
    </a>
  </div>
</div>
